import { LandingLayout } from '@hotjar/webapp/components/Landing';
import { useUIState } from '@hotjar/webapp/features/Core/hooks/useUIState';
import * as React from 'react';
import { useCallback, useEffect, useState } from 'react';
import { useTranslationWithPrefix } from '@hotjar/translations';
import { Button } from '@hotjar/hotsauce';
import { TextHorizontalRule } from '@hotjar/webapp/components/TextHorizontalRule';
import { useNavigate } from 'react-router-dom';
import {
  ENFORCE_MFA_ENABLE_MFA,
  ENFORCE_MFA_VERIFY_EMAIL,
} from '@hotjar/webapp/constants/routes/mfa';
import { usePartialCurrentUser } from '@hotjar/user';
import { MfaEnforceLandingPageStyle } from './style';

const { Wrapper, BottomButtons, Title, Description } = MfaEnforceLandingPageStyle;

export const MfaEnforceSetupLandingPage = (): JSX.Element => {
  const { setIsAppInterfaceVisible } = useUIState();
  const { t } = useTranslationWithPrefix('mfa:secure-with-2fa');
  const { isFetched, data: user, isLoading } = usePartialCurrentUser();
  const [nextAction, setNextAction] = useState<'EMAIL_VERIFICATION' | 'MFA_ACTIVATION'>();

  const navigate = useNavigate();

  useEffect(() => {
    setIsAppInterfaceVisible(false);
  }, [setIsAppInterfaceVisible]);

  const navigateLogin = useCallback(() => {
    navigate('/login');
  }, [navigate]);

  useEffect(() => {
    if (isFetched) {
      if (user) {
        if (!user.isEmailVerified) {
          setNextAction('EMAIL_VERIFICATION');
        } else if (!user.hasMfaEnabled) {
          setNextAction('MFA_ACTIVATION');
        } else {
          navigate('/');
        }
      } else {
        navigateLogin();
      }
    }
  }, [navigate, navigateLogin, isFetched, user]);

  const onNext = () => {
    if (nextAction === 'EMAIL_VERIFICATION') {
      navigate(`${ENFORCE_MFA_VERIFY_EMAIL.path}${window.location.search}`);
    }

    if (nextAction === 'MFA_ACTIVATION') {
      navigate(`${ENFORCE_MFA_ENABLE_MFA.path}${window.location.search}`);
    }
  };

  return (
    <LandingLayout isLoading={isLoading} background="COBALT_100" isTraceLineActive>
      <Wrapper>
        <Title>{t('title')}</Title>
        <Description>{t('description')}</Description>
        <BottomButtons>
          <Button kind="primary" onClick={onNext} type="submit">
            {t('action')}
          </Button>
          <TextHorizontalRule message={t('horizontal-text')} />
          <Button kind="secondary" onClick={navigateLogin}>
            {t('back')}
          </Button>
        </BottomButtons>
      </Wrapper>
    </LandingLayout>
  );
};
